// @flow

import React from 'react';
import { connect } from 'react-redux';
import {
  getMethodsForActiveAccessory,
  toggleAccessory,
} from '../../../../../store/configuration';
import ExtraTile from './extraTile';
import type { Accessory } from '../../../../../types/pdb';

type OwnProps = {|
  accessory: Accessory,
  blockCount: number,
|};

type StateProps = {|
  activeMethods: string[],
|};

type DispatchProps = {|
  toggleExtra: Function,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};

const AccessoryComponent = ({
  accessory,
  activeMethods,
  blockCount,
  toggleExtra,
}: Props) => (
  <ExtraTile
    activeMethods={activeMethods}
    blockCount={blockCount}
    extra={accessory}
    toggleExtra={toggleExtra}
  />
);

const mapStateToProps = (state: any, { accessory: { id } }: OwnProps): StateProps => ({
  activeMethods: getMethodsForActiveAccessory(state, id),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  toggleExtra: (id: number) => dispatch(toggleAccessory(id, 'selected')),
});

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(AccessoryComponent);
